import { render, staticRenderFns } from "./GameGrid.vue?vue&type=template&id=16ff0f28&scoped=true"
import script from "./GameGrid.vue?vue&type=script&lang=js"
export * from "./GameGrid.vue?vue&type=script&lang=js"
import style0 from "./GameGrid.vue?vue&type=style&index=0&id=16ff0f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff0f28",
  null
  
)

export default component.exports